import instObj from '@/backend/axios-instances'

const resource = "/orders/details/storages"
const instance = instObj.baseInstance

export default {
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  }
}
